import React, { ReactNode } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

interface AnimatedSectionProps {
    children: ReactNode;
    className?: string;
}

export const AnimatedSection: React.FC<AnimatedSectionProps> = ({ children, className = '' }) => {
    const { ref, isVisible } = useScrollAnimation();
    
    return (
        <div 
            ref={ref}
            className={`transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            } ${className}`}
        >
            {children}
        </div>
    );
};
